import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import YearChooser, {direction, getCurrentYear} from "../Common/YearChooser";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import RequestDialog from "./RequestDialog";
import PrintRequest from "./PrintRequest";
import i18next from "i18next";

class DayOff extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: getCurrentYear(), requestDialogVisible: false, requestPrintVisible: false, currentRowKey: -1
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.WorkHoliday_ListForPersTotalsPo.execute(key));
            await this.props.dispatch(this.props.WorkHoliday_ListForPersPo.execute(Object.assign({}, key, {"ViewYear": this.state.currentYear})));
            await this.props.dispatch(this.props.CompHolidayApp_ListPO.execute(key));
        } catch (e) {
            console.error(e);
        }
    }

    async refresh() {
        let key = {};
        await this.props.dispatch(this.props.CompHolidayApp_ListPO.execute(key));
    }

    changeYear = (year) => {
        this.setState({currentYear: Number.parseInt(year)}, this.initialize)
    }

    createNewRequest = () => {
        this.setState({requestDialogVisible: true})
    }

    printRequest = (rowIndex, row) => {
        let rowKey = this.props.CompHolidayApp_ListPO.getRowKey(row);
        this.setState({requestPrintVisible: true, currentRowKey: rowKey})
    }

    render() {

        return (<>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-chain-broken'/> {i18next.t("DayOff_WorkedHours")}</>}
                                    showSplitterLine={false} canCollapse={false}>
                    <GridView dataItem={this.props.WorkHoliday_ListForPersTotalsPo}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-bank'/> {i18next.t("DayOff_HolidayWorkOrders")}</>}
                                    showSplitterLine={true} canCollapse={true}>
                    <YearChooser currentYear={this.state.currentYear} changeYear={this.changeYear}
                                 order={direction.Desc}
                                 firstYear={{Title: i18next.t("All"), Value: -1}}
                                 label={i18next.t("DayOff_HolidayWorkOrdersFor")}/>
                    <GridView dataItem={this.props.WorkHoliday_ListForPersPo}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="30"
                                    title={<><i className="fa fa-file-text-o"></i> {i18next.t("DayOff_EmployeeDayOffStatement")}</>}
                                    showSplitterLine={false} canCollapse={true}>

                    <button type="button" className="btn btn-regular -goahead"
                            title={i18next.t("CreateStatement")} onClick={this.createNewRequest}>
                        {i18next.t("CreateStatement")}
                    </button>
                    <br/>

                    <div>
                        <GridView dataItem={this.props.CompHolidayApp_ListPO} readOnly={true} allowPagination={true}
                                  onRowClick={this.printRequest}
                            //                      renderCell={this.renderCell}
                        />
                    </div>
                    {this.state.requestDialogVisible && <RequestDialog dataItem={this.props.CompHolidayApp_ListPO}
                                                                       onClose={() => {
                                                                           this.setState({requestDialogVisible: false});
                                                                           this.refresh();
                                                                       }}/>}
                    {this.state.requestPrintVisible && <PrintRequest rowKey={this.state.currentRowKey}
                                                                     onClose={() => this.setState({requestPrintVisible: false})}/>}
                </PlaceholderWrapper>
            </>)
    }
}

DayOff.propTypes = {
    dispatch: PropTypes.func.isRequired,
    WorkHoliday_ListForPersPo: PropTypes.object,
    WorkHoliday_ListForPersTotalsPo: PropTypes.object,
    CompHolidayApp_ListPO: PropTypes.object,
    CompHolidayApp_NewPO: PropTypes.object,
    CompHolidayApp_DelPO: PropTypes.object,
    CompHolidayApp_PrintPO: PropTypes.object
}

DayOff.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        WorkHoliday_ListForPersPo: state.dayOffState.WorkHoliday_ListForPersPo,
        WorkHoliday_ListForPersTotalsPo: state.dayOffState.WorkHoliday_ListForPersTotalsPo,
        CompHolidayApp_ListPO: state.dayOffState.CompHolidayApp_ListPO,
        CompHolidayApp_NewPO: state.dayOffState.CompHolidayApp_NewPO,
        CompHolidayApp_DelPO: state.dayOffState.CompHolidayApp_DelPO,
        CompHolidayApp_PrintPO: state.dayOffState.CompHolidayApp_PrintPO
    }
}

export default connect(mapStateToProps)(DayOff)